import PropTypes from 'prop-types';
import React from 'react';

import * as styles from './BeefSammy.module.css';

const BeefSammy = ({ open, onClick }) => {
  let buttonClass = styles.beefSammy;
  if (open) {
    buttonClass = styles.beefSammyOpen;
  }
  return (
    <button className={buttonClass} onClick={onClick} type="button" aria-label="Open and close navigation menu">
      <span className={styles.bar1} />
      <span className={styles.bar2} />
    </button>
  );
};

BeefSammy.propTypes = {
  open: PropTypes.bool,
  onClick: PropTypes.func,
};

export default BeefSammy;
